export interface IGetAllRoleParams {
  page?: number;
  pageSize?: number;
  searchValue?: string;
}

export const ROLE_VARIABLES = {
  GET_ALL_ROLE_BY_FILTER: (params: IGetAllRoleParams) => {
    return {
      ...(params?.page &&
        params?.pageSize && {
          skip: params.page * params.pageSize,
        }),
      ...(params?.pageSize && { take: params.pageSize }),
      ...(params?.searchValue && { name: params.searchValue?.trim() }),
    };
  },
};
